import { useState, useEffect } from "react";
import { FaBars, FaTimes } from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
import { Button } from '../../GlobalStyles';
import { 
 Nav,
 NavbarContainer,
 NavLogo,
 NavIcon,
 HarmburgerMenu,
 NavMenu,
 NavItem,
 NavLinks,
 NavItemBtn,
 NavBtnLink
} from "./Navbar.elements";


const Navbar = () => {
    const [click, setClick] = useState(false);
    const [button, setButton] = useState(true);

    const handleClickEvent = () => setClick(!click);
    const closeMobileMenu = () => setClick(false);

    const showButton = () => {
        if (window.innerWidth <= 960) {
          setButton(false);
        } else {
          setButton(true);
        }
      };
    
      useEffect(() => {
        showButton();
      }, []);
    
      window.addEventListener('resize', showButton);

    return (
        <>
        <IconContext.Provider value={{ color: '#fff' }}>
            <Nav>
                <NavbarContainer>
                    <NavLogo to="/">
                        <NavIcon />
                        LIGHT HOUSE
                    </NavLogo>
                    <HarmburgerMenu onClick={handleClickEvent}>
                        {click ? <FaTimes /> : <FaBars />}
                    </HarmburgerMenu>
                    <NavMenu onClick={handleClickEvent} click={click}>
                        <NavItem>
                            <NavLinks to="/" onClick={closeMobileMenu}>Home</NavLinks>
                        </NavItem>
                        <NavItem>
                            <NavLinks to="/services" onClick={closeMobileMenu}>Services</NavLinks>
                        </NavItem>
                        <NavItem>
                            <NavLinks to="/products" onClick={closeMobileMenu}>Products</NavLinks>
                        </NavItem>
                        <NavItemBtn>
                        {button ? (
                            <NavBtnLink to='/sign-up'>
                                <Button primary>SIGN UP</Button>
                            </NavBtnLink>
                            ) : (
                            <NavBtnLink to='/sign-up'>
                                <Button onClick={closeMobileMenu} fontBig primary>
                                SIGN UP
                                </Button>
                            </NavBtnLink>
                            )}
                        </NavItemBtn>
                    </NavMenu>
                </NavbarContainer>
            </Nav>
            </IconContext.Provider>
        </>
    );
}

export default Navbar;
